import { atom } from 'jotai';

const sortDrawerOpenAtom = atom(false);

export { sortDrawerOpenAtom };
